import "core-js/modules/web.dom.iterable";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { getAssetInfoStatistical } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '30px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    type: {},
    id: {}
  },
  watch: {
    id: {
      handler: function handler(val) {
        this.querySewageQuotaList(this.type, val);
      },
      immediate: true
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  methods: {
    initBarChart: function initBarChart(data) {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          }
        },
        legend: {
          data: data.legendData,
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: data.xData,
          nameTextStyle: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{
          type: 'value',
          nameTextStyle: {
            color: '#fff'
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        }],
        series: data.seriesData
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    },
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(scope, scopeId) {
      var _this = this;

      getAssetInfoStatistical({
        scope: scope,
        scopeId: scopeId,
        current: 1,
        size: 100000000000
      }).then(function (res) {
        var data1 = [],
            data2 = [];
        var data = {
          xData: [],
          seriesData: [],
          legendData: ['有效', '无效']
        };
        res.result.records.forEach(function (v, i) {
          if (scope == 1) {
            data.xData.push(v.productName);
          } else {
            data.xData.push(v.siteName);
          }

          data1.push(v.validNum);
          data2.push(v.noValidNum);
        });
        data.seriesData = [{
          name: '有效',
          type: 'bar',
          stack: '预警',
          data: data1
        }, {
          name: '无效',
          type: 'bar',
          stack: '预警',
          data: data2
        }];

        _this.initBarChart(data);
      });
    }
  }
};